(function () {
  if (!Array.isArray(window.variations_new)) return;

  const container = document.getElementById('var-inside');
  if (!container) return;

  container.innerHTML = '';

  let hasLinks = false;

  variations_new.forEach(p => {
    if (!p || !p.url) return;

    let label = p.title || p.handle || p.url;
    const idx = label.lastIndexOf(' - ');
    if (idx !== -1) {
      label = label.slice(idx + 3);
    }

    const a = document.createElement('a');
    a.href = p.url;
    a.textContent = label;
    container.appendChild(a);

    hasLinks = true;
  });

  if (!hasLinks) return;

  let tries = 0;
  const maxTries = 50;

  const timer = setInterval(() => {
    tries++;
    if (tries > maxTries) {
      clearInterval(timer);
      return;
    }

    const titleEl = document.querySelector('.h1.product-single__title');
    if (!titleEl) return;

    let txt = titleEl.textContent.trim();
    const dashIdx = txt.lastIndexOf(' - ');
    if (dashIdx !== -1) {
      txt = txt.slice(dashIdx + 3);
    }

    const currentLabel = txt || '';
    if (!currentLabel) return;

    if (!container.querySelector('span[data-current-variant="true"]')) {
      const span = document.createElement('span');
      span.textContent = currentLabel;
      span.setAttribute('data-current-variant', 'true');
      container.insertBefore(span, container.firstChild);
    }

    const variantWrapper = document.querySelector('.variant-wrapper.small--text-center.js');
    if (variantWrapper) {
      variantWrapper.style.display = 'none';
    }

    clearInterval(timer);
  }, 200);
})();
